export default __webpack_public_path__ + "static/social_card_intrmodl-8a6e243c48932ab13abc33423461325f.png";